import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimAddress',
})
export class TrimAddressPipe implements PipeTransform {
  transform(value: string, startLength: number = 6, endLength: number = 5): string {
    if (value) {
      // Use the dynamic lengths for slicing
      const address = value.slice(0, startLength) + '...' + value.slice(value.length - endLength);
      return address;
    } else {
      return '-';
    }
  }
}
